var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.408,
    height: 24.945,
    viewBox: "0 0 34.408 24.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Map_Legend_250121",
    "data-name": "noun_Map Legend_250121",
    transform: "translate(-5.375 -16.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(5.375 16.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M34.583,24.967H56.795a.683.683,0,1,0,0-1.367H34.583a.683.683,0,0,0,0,1.367Z",
    transform: "translate(-23.07 -21.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M56.757,47.3H34.583a.683.683,0,1,0,0,1.367H56.795a.681.681,0,0,0,.683-.683A.714.714,0,0,0,56.757,47.3Z",
    transform: "translate(-23.07 -35.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M56.757,70.9H34.583a.683.683,0,0,0,0,1.367H56.795a.681.681,0,0,0,.683-.683A.714.714,0,0,0,56.757,70.9Z",
    transform: "translate(-23.07 -50.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M12.155,39.7H6.383a.681.681,0,0,0-.683.683v5.771a.681.681,0,0,0,.683.683h5.771a.681.681,0,0,0,.683-.683V40.383A.734.734,0,0,0,12.155,39.7Z",
    transform: "translate(-5.577 -31.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M6.03,23.392h5.923a.626.626,0,0,0,.57-.342.726.726,0,0,0,0-.683L9.561,17.242a.706.706,0,0,0-.57-.342.626.626,0,0,0-.57.342L5.46,22.405a.725.725,0,0,0,0,.683A.593.593,0,0,0,6.03,23.392Z",
    transform: "translate(-5.375 -16.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M9.2,62.6a3.8,3.8,0,1,0,3.8,3.8A3.808,3.808,0,0,0,9.2,62.6Z",
    transform: "translate(-5.391 -45.249)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLegend);
export default __webpack_public_path__ + "static/media/mapLegend.623fb9b1aceba769b2efe80d6fa652ba.svg";
export { ForwardRef as ReactComponent };